export default __webpack_public_path__ + "static/media/number-17.addac1ac.png";